<!--
  name : 김혜진
  desc : (리뉴얼)이용요금
  date : 2020-11-26
-->
<template>
  <v-container>
    <v-row no-gutters id="feepay">
      <v-col cols="12">
        <v-row no-gutters class="feepay_round_box row_mb-40">
          <v-col cols="12" class="posiR">
            <ul class="pattern_ulTxtBox minH24">
              <li>
                <!--conFrom:개인, conFrom st_cpn:기업-->
                <v-chip class="conFrom st_cpn">기업</v-chip>
                <span class="txt_txt01 no_pr">{{ ownName }}</span>
                <span class="txt_txt02"
                  >({{ getOrgreg() | regNumFilter }})</span
                >
              </li>
              <li>
                <span class="txt_tt">기업 관리자</span>
                <span class="txt_txt02">{{ companyAdmin }}</span>
                <span class="txt_txt02">({{ companyAdminEmail }})</span>
              </li>
              <li>
                <v-btn
                  text
                  class="btn17_C01 btn_feeP_cpn_pay"
                  @click="poPcpnPoint"
                  >요금 현황</v-btn
                >
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-col>
      <v-row no-gutters class="feepay_con">
        <v-col cols="12" class="row_mb-40">
          <div class="dot_tt">내 요금제</div>
          <span class="cash_icon"></span>
          <span class="txtst_info_gray">남은 건수</span>
          <v-row no-gutters class="align-center">
            <v-col cols="auto">{{ availableNumber | WithComma }}건</v-col>
            <!--<v-col cols="auto" class="ml-2 txtst_info_gray">2020-12-15</v-col>-->
          </v-row>
        </v-col>
        <v-col cols="12" class="row_mb-20">
          <div class="dot_tt">요금 결제</div>
          <div class="row_mt-20 txtst_info_gray">
            <span class="fc_C03">[건당 요금제]</span><br />사용한 만큼만
            결제하는 합리적인 요금제로 365일 간 자유롭게 사용할 수 있습니다.
          </div>
          <!--
            <div class="round8_pd20_box box_st_n_cert">
              <div class="roundCbox_ttCon">
                <span class="roundCbox_tt for_newPay">건당 요금제</span>
              </div>
              <span class="roundCbox_newPay_txt">사용한 만큼만 결제하는 합리적인 요금제로 365일 간 자유롭게 사용할 수 있습니다.</span>
            </div>-->
        </v-col>
        <v-col cols="12" class="newPay_carD_list row_mb-40">
          <!--(반복)건당 요금카드-->
          <v-card outlined class="newPay_carD_con">
            <v-checkbox
              class="doc_type_chk"
              hide-details
              v-model="ctrPay"
              value="3000"
              @click="checkPay('3000')"
            ></v-checkbox>
            <v-card-text class="carD_box">
              <div class="icon_sale"></div>
              <div class="txt_count">1 건</div>
              <div><span class="txt_price">3,000</span><span>원</span></div>
              <div class="txt_cp">/ 건당 3,000 원</div>
            </v-card-text>
          </v-card>
          <!--/(반복)건당 요금카드-->

          <!--건당 요금카드2-->
          <v-card outlined class="newPay_carD_con">
            <v-checkbox
              class="doc_type_chk"
              v-model="ctrPay"
              value="20000"
              @click="checkPay('20000')"
              hide-details
            >
            </v-checkbox>
            <v-card-text class="carD_box">
              <div class="icon_sale">33%</div>
              <div class="txt_count">10 건</div>
              <div><span class="txt_price">20,000</span><span>원</span></div>
              <div class="txt_cp">/ 건당 2,000 원</div>
            </v-card-text>
          </v-card>
          <!--/건당 요금카드2-->
          <!--건당 요금카드3-->
          <v-card outlined class="newPay_carD_con">
            <v-checkbox
              class="doc_type_chk"
              v-model="ctrPay"
              value="60000"
              @click="checkPay('60000')"
              hide-details
            >
            </v-checkbox>
            <v-card-text class="carD_box">
              <div class="icon_sale">60%</div>
              <div class="txt_count">50 건</div>
              <div><span class="txt_price">60,000</span><span>원</span></div>
              <div class="txt_cp">/ 건당 1,200 원</div>
            </v-card-text>
          </v-card>
          <!--/건당 요금카드3-->
          <!--건당 요금카드4-->
          <v-card outlined class="newPay_carD_con">
            <v-checkbox
              class="doc_type_chk"
              v-model="ctrPay"
              value="100000"
              @click="checkPay('100000')"
              hide-details
            >
            </v-checkbox>
            <v-card-text class="carD_box">
              <div class="icon_sale">67%</div>
              <div class="txt_count">100 건</div>
              <div><span class="txt_price">100,000</span><span>원</span></div>
              <div class="txt_cp">/ 건당 1,000 원</div>
            </v-card-text>
          </v-card>
          <!--/건당 요금카드4-->
          <!--건당 요금카드5-->
          <v-card outlined class="newPay_carD_con">
            <v-checkbox
              class="doc_type_chk"
              v-model="ctrPay"
              value="270000"
              @click="checkPay('270000')"
              hide-details
            >
            </v-checkbox>
            <v-card-text class="carD_box">
              <div class="icon_sale">70%</div>
              <div class="txt_count">300 건</div>
              <div><span class="txt_price">270,000</span><span>원</span></div>
              <div class="txt_cp">/ 건당 900 원</div>
            </v-card-text>
          </v-card>
          <!--/건당 요금카드5-->
        </v-col>
        <v-col cols="12" class="row_mb-40" align="top">
          <div class="dot_tt">결제방법</div>
          <ul class="pattern_ulTxtBox ofV">
            <li>
              <v-radio-group class="radioCon" row>
                <v-radio
                  label="신용카드"
                  :value="SC0010"
                  v-on:click="ctrPayTypeSelect(SC0010)"
                ></v-radio>
                <v-radio
                  label="실시간계좌이체"
                  :value="SC0030"
                  v-on:click="ctrPayTypeSelect(SC0030)"
                ></v-radio>
                <v-radio
                  class="no-mr"
                  label="무통장입금"
                  :value="SC0040"
                  v-on:click="ctrPayTypeSelect(SC0040)"
                ></v-radio>
                <v-text-field
                  class="pay_type03 inputH48_03 conBstar"
                  hide-details
                ></v-text-field>
                <v-radio
                  label="휴대폰 결제"
                  :value="SC0060"
                  v-on:click="ctrPayTypeSelect(SC0060)"
                ></v-radio>
              </v-radio-group>
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-col cols="12" class="feepay_FbtnCon">
        <v-btn class="btn19_C01" @click="charge">충전하기</v-btn>
      </v-col>
    </v-row>
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
    <v-dialog
      append-to-body
      ref="pgPopup"
      top="1vh"
      title="글로싸인엔터프라이즈 결제 서비스"
      v-model="pgVisible"
      width="680px"
      :before-close="paymentBeforeClose"
    >
      <div>
        <form
          type="hidden"
          id="pgRequestForm"
          ref="pgRequestForm"
          target="pgframe"
          :action="payreqCrossplatform"
        >
          <input
            type="hidden"
            name="LGD_BUYER"
            id="LGD_BUYER"
            :value="accountName"
          />
          <input
            type="hidden"
            name="LGD_PRODUCTINFO"
            id="LGD_PRODUCTINFO"
            value="글로싸인 엔터프라이즈 사용료"
          />
          <input
            type="hidden"
            name="LGD_PRODUCTCODE"
            id="LGD_PRODUCTCODE"
            value="Sign"
          />
          <input
            type="hidden"
            name="LGD_AMOUNT"
            id="LGD_AMOUNT"
            :value="calculVatAndAmount()"
          />
          <input
            type="hidden"
            name="LGD_BUYEREMAIL"
            id="LGD_BUYEREMAIL"
            :value="email"
          />
          <input
            type="hidden"
            name="LGD_OID"
            id="LGD_OID"
            :value="'sec' + makeoid()"
          />

          <input
            type="hidden"
            name="LGD_ID"
            id="LGD_ID"
            :value="this.$store.state.user.userid"
          />

          <input
            type="hidden"
            name="LGD_TIMESTAMP"
            id="LGD_TIMESTAMP"
            :value="makeoid()"
          />
          <input
            type="hidden"
            name="LGD_CUSTOM_USABLEPAY"
            id="LGD_CUSTOM_USABLEPAY"
            :value="paymentMethod"
          />
          <input
            type="hidden"
            name="PAY_ACTIVENAME"
            id="PAY_ACTIVENAME"
            :value="activeName"
          />
          <input
            type="hidden"
            name="PAY_CHAINADDR"
            id="PAY_CHAINADDR"
            :value="getChainAddress()"
          />
        </form>
      </div>
      <iframe
        v-if="pgVisible"
        width="100%"
        height="650px"
        id="pgframe"
        ref="pgframe"
        name="pgframe"
      >
      </iframe>
    </v-dialog>
    <fee-pay
      ref="feePay"
      :chainAddr="getChainAddress()"
      isType="UR0010"
      :companyName="ownName"
      :comRegno="getOrgreg()"
      :currCash="availableNumber"
      :comPanyUsr="companyAdmin + '(' + companyAdminEmail + ')'"
    ></fee-pay>
    <v-dialog
      max-width="600px"
      title="무통장입금 결제정보"
      v-model="directDepositVisible"
    >
      <v-card id="popStyle02">
        <!--팝업 내용-->
        <v-card-text class="directDepositInfo">
          <v-row no-gutters class="justify-center popCon">
            <v-col cols="12" class="ta_center row_mb-40">
              <div>아래 입금정보를 확인하신 후, 전용계좌로 송금해주세요.</div>
            </v-col>
            <v-col cols="12" class="row_mb-20">
              <div class="round8_pd20_box">
                <ul class="pattern_ulTxtBox liW100">
                  <li class="ta_left">
                    <span class="txt_tt w8em">입금은행</span>
                    <span class="txt_txt01">{{
                      directDepositInfo.financeName
                    }}</span>
                  </li>
                  <li class="ta_left">
                    <span class="txt_tt w8em">계좌번호</span>
                    <span class="txt_txt01 fc_p02">{{
                      directDepositInfo.accountNum
                    }}</span>
                  </li>
                  <li class="ta_left">
                    <span class="txt_tt w8em">입금액</span>
                    <span class="txt_txt01">{{
                      directDepositInfo.amount | moneyWithComma
                    }}</span>
                  </li>
                  <li class="ta_left">
                    <span class="txt_tt w8em">예금주</span>
                    <span class="txt_txt01">{{
                      directDepositInfo.receiver
                    }}</span>
                  </li>
                  <li class="ta_left">
                    <span class="txt_tt w8em">입금인</span>
                    <span class="txt_txt01">{{ directDepositInfo.payer }}</span>
                  </li>
                  <li class="ta_left">
                    <span class="txt_tt w8em">입금유효기간</span>
                    <span class="txt_txt01">{{
                      directDepositInfo.expirationDate
                    }}</span>
                  </li>
                </ul>
              </div>
            </v-col>
            <v-col cols="12" class="row_mb-40">
              <ul class="pattern_ul_terms ta_left">
                <li>
                  - 가상계좌는 일회성 계좌이므로 재사용시(다시 그 계좌로
                  입금하는 경우) 타인의 계좌로 입금될 가능성이 있습니다. 이
                  경우는 구매고객의 책임이므로 사용에 주의하시기 바랍니다.
                </li>
                <li>
                  - CD기에서 계좌이체는 가능하나 CD기에서 해당 계좌로 현금을
                  입금할 수는 없습니다. (과오납이 허용되지 않을 수 있으니 CD기
                  이용은 지양해 주시기 바랍니다.)
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn type="primary" @click="paymentInfoBeforeClose">닫기</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { getCurrPoint } from "@/api/payment/payment";
import { isEntryAdmin } from "@/api/user";
import feePay from "@/views/feepay/components/feepay.vue";

export default {
  name: "newPay",
  components: {
    feePay
  },
  filters: {
    regNumFilter: function(value) {
      if (value) {
        return String(value).replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
      }
    },
    WithComma: function(money) {
      if (String(money)) {
        return String(money).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    moneyWithComma: function(money) {
      if (String(money)) {
        return String(money).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  },
  data() {
    return {
      /* 회사 관리자 */
      companyAdmin: "",
      /* 회사 관리자 이메일 */
      companyAdminEmail: "",
      /* 이용 가능 포인트 */
      availableNumber: 0,
      /* 이용 가능 포인트 */
      availablePoint: 0,
      /* 충전 방법 */
      paymentMethod: "SC0010",
      SC0010: "SC0010",
      SC0030: "SC0030",
      SC0040: "SC0040",
      SC0060: "SC0060",
      ctrPay: [],
      /* 충전액 */
      paymentAmount: 0,
      /* 구매자 */
      buyer: "",
      /* 구매자 (회사 명) */
      ownName: null,
      /* 기업 사용자 여부 */
      isOrgUsr: 0,
      /* 활성화된 탭 */
      activeName: "personal",
      /* 블록체인 주소 */
      chainAddress: "",
      // 예금주명
      accountName: "",
      /* 충전한 사용자 이메일 */
      email: this.$store.state.user.useremail,
      payreqCrossplatform: process.env.VUE_APP_URL_PAYREQ_CROSSPLATFORM,
      /* PG 창 활성화 여부 */
      pgVisible: false,
      /* 무통장입금 결제정보창 활성화 여부 */
      directDepositVisible: false,
      /* 무통장 결제 정보 */
      directDepositInfo: {
        financeName: "",
        payer: "",
        accountNum: "",
        amount: 0,
        receiver: "(주)비즈니스온커뮤니케이션",
        expirationDate: ""
      },
      /* 계약 또는 기업 관리자 여부 */
      isEntryAdmin: true
    };
  },
  computed: {},
  created() {
    const orgName = this.$store.state.user.orgname;
    const userName = this.$store.state.user.username;
    if (orgName) {
      this.activeName = "company";
      this.isOrgUsr = 1;
      this.ownName = orgName;
      this.accountName = this.ownName;
      this.getIsEntryAdmin();
    } else {
      this.activeName = "personal";
      this.isOrgUsr = 0;
      this.ownName = userName;
      this.accountName = this.ownName;
    }
  },
  mounted() {
    this.getCurrPoint();
    window.addEventListener("message", this.resultMessage, true);
  },
  methods: {
    getCurrPoint() {
      getCurrPoint({
        chainAddr: this.getChainAddress(),
        activeName: this.activeName
      })
        .then(response => {
          if (response.rdata.code === 1) {
            this.availablePoint = response.rdata.currPoint;
            this.availableNumber = parseInt(this.availablePoint / 3000);
          } else {
            this.$refs.confirm("alert", "포인트 조회", response.rdata.message);
          }
        })
        .catch(e => {
          // console.log(e)
        });
    },
    getIsEntryAdmin() {
      isEntryAdmin()
        .then(response => {
          this.isEntryAdmin = response.rdata.isEntryAdmin;
          this.companyAdmin = response.rdata.orgAdmin;
          this.companyAdminEmail = response.rdata.adminEmail;
        })
        .catch(e => {
          // console.log(e)
        });
    },
    getOrgreg() {
      return this.$store.state.user.orgreg;
    },
    calculVatAndAmount() {
      var afterVatAmount = this.paymentAmount;
      return parseInt(afterVatAmount);
    },
    makeoid() {
      var now = new Date();
      var years = now.getFullYear();
      var months = this.LPad(now.getMonth() + 1, 2, "0");
      var dates = this.LPad(now.getDate(), 2, "0");
      var hours = this.LPad(now.getHours(), 2, "0");
      var minutes = this.LPad(now.getMinutes(), 2, "0");
      var seconds = this.LPad(now.getSeconds(), 2, "0");
      var timeValue = years + months + dates + hours + minutes + seconds;

      return timeValue;
    },
    LPad(digit, size, attatch) {
      var add = "";
      digit = digit.toString();

      if (digit.length < size) {
        var len = size - digit.length;
        for (var i = 0; i < len; i++) {
          add += attatch;
        }
      }
      return add + digit;
    },
    getChainAddress() {
      var chainAddr;
      if (this.activeName === "company") {
        chainAddr = this.$store.state.user.orgaddr;
      } else {
        chainAddr = this.$store.state.user.useraddr;
      }

      return chainAddr;
    },
    charge() {
      if (this.paymentAmount === 0) {
        this.$refs.confirm.open("alert", "결제", "결제금액을 선택해주세요.");
      } else {
        this.pgVisible = true;
        this.makeoid();
        setTimeout(() => this.goCharge(), 1000);
      }
    },
    goCharge() {
      var pgform = this.$refs.pgRequestForm;
      pgform.submit();
    },
    resultMessage(e) {
      if (e.data.auth !== undefined && this.pgVisible) {
        if (e.data.auth === "true") {
          if (e.data.signal === "I") {
            this.$refs.confirm.open(
              "alert",
              "충전",
              "포인트 충전이 완료되었습니다."
            );
            this.getCurrPoint();
            this.pgVisible = false;
          } else if (e.data.signal === "R") {
            var payer = e.data.payer;
            var accountNum = e.data.accountNum;
            var amount = e.data.amount;
            var financeName = e.data.financeName;

            this.directDepositInfo.payer = payer;
            this.directDepositInfo.accountNum = accountNum;
            this.directDepositInfo.amount = amount;
            this.directDepositInfo.financeName = financeName;
            this.directDepositInfo.expirationDate = this.accountExpirationDate();

            this.directDepositVisible = true;
            this.pgVisible = false;
          }
        } else {
          this.pgVisible = false;
        }
      }
    },
    ctrPayTypeSelect(data) {
      this.paymentMethod = data;
    },
    checkPay(pay) {
      this.ctrPay = [];
      this.ctrPay.push(pay);
      this.paymentAmount = pay * 1.1;
    },
    poPcpnPoint() {
      this.$refs.feePay.open();
    },
    paymentBeforeClose() {
      this.$refs.confirm
        .open(
          "alert",
          "충전",
          "이 창을 닫으시면 지금까지 작성하신 결제정보가 모두 사라집니다. 결제 창을 종료하시겠습니까?"
        )
        .then(() => {
          this.pgVisible = false;
        });
    },
    accountExpirationDate() {
      var date = new Date();
      return (
        date.getFullYear() +
        "/" +
        (date.getMonth() + 1) +
        "/" +
        (date.getDate() + 1) +
        " " +
        "23:59"
      );
    },
    paymentInfoBeforeClose() {
      this.$refs.confirm
        .open(
          "confirm",
          "무통장 입금 결제정보",
          "이 창을 닫으시면 더이상 결제정보를 확인할 수 없습니다. 결제정보 창을 종료하시겠습니까?"
        )
        .then(() => {
          this.getCurrPoint();
          this.directDepositVisible = false;
        });
    }
  }
};
</script>
<style scoped></style>
